import { useTranslation } from 'react-i18next';
import { Box, Button, Loader } from 'ui';
import { ButtonProps } from 'ui/components/Button/types';
import { useResolution } from 'ui/hooks';
import { Download } from 'ui/icons';

interface Props extends Omit<ButtonProps, 'startIcon' | 'children'> {
  downloadUrl?: string;
}

export const ContractDownloadButton = ({ downloadUrl, loading, ...rest }: Props) => {
  const { isTablet } = useResolution();
  const { t } = useTranslation('contracts');

  const buttonSize = isTablet ? 'lg' : 'sm';

  const downloadFile = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    window.open(downloadUrl, '_blank', 'noopener noreferrer');
  };

  return (
    <Box>
      <Button
        onClick={downloadFile}
        size={buttonSize}
        startIcon={loading ? <Loader size={20} /> : <Download />}
        disabled={loading}
        {...rest}
      >
        {loading ? t('fileLoading') : t('downloadContract')}
      </Button>
    </Box>
  );
};
